import { ReactElement } from 'react';
import RuleLibrary from 'pages/campaign/iteration/[iterationId]/RuleLibrary';
import RulePage from 'pages/campaign/iteration/[iterationId]/Rule';
import RoutingIDsPage from 'pages/campaign/iteration/[iterationId]/routing-rules/[ruleId]/RoutingPlan';

const createRoutingRuleRoutes = (withCampaignLoader: (component: ReactElement) => ReactElement) => ({
  path: 'routing-rules',
  children: [
    {
      path: ':ruleId',
      element: withCampaignLoader(<RulePage ruleTypeFromRoute="R" />),
      children: [
        {
          path: 'and-clause/:andClauseNumber',
          element: withCampaignLoader(<RulePage ruleTypeFromRoute="R" />),
        },
      ],
    },
    { path: ':ruleId/library', element: withCampaignLoader(<RuleLibrary ruleType="R" />) },
    { path: ':ruleId/and-clause/:andClauseNumber/library', element: withCampaignLoader(<RuleLibrary ruleType="R" />) },
    { path: ':ruleId/routing-ids', element: withCampaignLoader(<RoutingIDsPage />) },
  ],
});

export default createRoutingRuleRoutes;
